module.exports = __webpack_public_path__ + "static/media/analise_mer.6d0c7fac.svg";